import { Observable, observe, Scope } from 'wdc-cube'

export type ExportDocumentRow = {
    seq: number
    exportId: number
    docType: string
    docId: string
    docLabel?: string
    dataHora: string
    userName?: string
}

export type ExportDocumentsResponse = {
    totalRecords: number
    page: number
    limit: number
    records: ExportDocumentRow[]
}

export const EMPTY_EXPORT_DOCUMENTS: ExportDocumentsResponse = {
    totalRecords: 0,
    page: 0,
    limit: 10,
    records: []
}

@Observable
export class ExportDocumentsScope extends Scope {
    @observe() open = false
    @observe() loading = false
    @observe() page = 0
    @observe() limit = 10
    @observe() data = EMPTY_EXPORT_DOCUMENTS as ExportDocumentsResponse

    onChangePage = Scope.ASYNC_ACTION_NUMBER
    onChangeRowsPerPage = Scope.ASYNC_ACTION_NUMBER
    onClose = Scope.ASYNC_ACTION
}
